import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import ExchangeRates from './ExchangeRates';
import mapExchangeRates from './mapExchangeRates';
import Rate from './Rate';

export interface Result {
	exchangeRates: ExchangeRates;
}

export default async function createExchangeRates(
	client: ApiClient,
	userId: string,
	name: string,
	baseCurrency: string,
	rates: Rate[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/exchange-rates').expand({
		userId,
	});
	const request = await client.fetch(url, {
		method: 'POST',
		body: JSON.stringify({
			name,
			baseCurrency,
			exchangeRates: rates.map((rate) => ({
				currency: rate.currency,
				factor: rate.factor,
			})),
		}),
	});
	const response = await request.json();
	return { exchangeRates: mapExchangeRates(response.exchangeRates) };
}
